export const API_ENDPOINT = 'user';
export const SIGN_UP_ENDPOINT = `${API_ENDPOINT}/signup`;
export const INVITATION_SIGN_UP_ENDPOINT = `${API_ENDPOINT}/invitation-signup`;

export const USER_RESOURCE_ENDPOINT = (resource, resourceId) => `${API_ENDPOINT}/${resource}` + (resourceId ? `/${resourceId}` : '');

export const RESOURCES = {
  Industries: 'industries',
  AfsLicences: 'afs-licences',
  CpdCategorys: 'areas-of-advice',
  CpdCategory: 'cpd-category',
  CpdCategoryProgress: 'cpd-category-progress',
  AcceptInvitation: 'accept-invitation',
  Subscription: 'subscription',
  LeaveTeam: 'leave-team',
  Qualification: 'qualifications',
  Support: 'support',
  Invoices: 'invoices',
  Profile: 'profile',
  Goals: 'goals',
  SnapshotReport: 'snapshot-report',
  Bookmarks: 'bookmarks'
};


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/endpoints.js